/* eslint-disable @typescript-eslint/consistent-generic-constructors */
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  AccionesRol,
  CategoriaGrupo,
  IConfigPerfil,
  IFilter,
  IGrupo,
  ILuminaria,
  IPopulate,
  IQueryParam,
} from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';
import { CrearEditarAgrupacionesComponent } from '../crear-editar-grupos/crear-editar-grupos.component';
import { GrupoEntidadRegistry } from '../asignador/grupo-entidad.registry';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../auxiliares/tabla/tabla.component';

import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';
import { GruposService } from '../../../../auxiliares/servicios/http/grupos.service';
import { ActivosService } from '../../../../auxiliares/servicios/http/activos.service';
import { filtrarComandosManuales } from '../../../../auxiliares/comandos-manuales.util';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PuestasService } from '../../../../auxiliares/servicios/http/puestas.service';
import { LuminariasService } from '../../../entidades/luminarias/service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import {
  TipoConfigActis,
  TipoConsultaActis,
} from '../../../entidades/luminarias/luminarias.types';
import {
  ComandosObjetivoService,
  Objetivo,
} from '../../../../auxiliares/servicios/comandos-objetivo.service';
import { LuminariasHttpService } from '../../../../auxiliares/servicios/http/luminarias.service';
import { ExportarLuminariasDialogComponent } from '../../../entidades/luminarias/luminarias/exportar-luminarias-dialog/exportar-luminarias-dialog.component';
import { DescargasService } from '../../../navigation/descargas/service';
import { escaparHtml } from '../../../../auxiliares/html-seguro.util';
import { colorMuestraHtml, estadoHtml } from '../../../../auxiliares/tabla/celdas';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-listado-grupos',
  templateUrl: './listado-grupos.component.html',
  styleUrl: './listado-grupos.component.scss',
})
export class ListadoGruposComponent implements OnInit, OnDestroy {
  helper = inject(HelperService);
  private lista2 = inject(Lista2Service);
  private formularios = inject(FormularioDialogService);
  private service = inject(GruposService);
  private dialogService = inject(DialogService);
  private route = inject(ActivatedRoute);
  private registryEntidades = inject(GrupoEntidadRegistry);
  private descargas = inject(DescargasService);
  private puestasService = inject(PuestasService);
  private luminariasFlowService = inject(LuminariasService);
  private comandos = inject(ComandosObjetivoService);
  private navigator = inject(Router);
  private luminariasHttp = inject(LuminariasHttpService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private activosService = inject(ActivosService);

  public categoria: CategoriaGrupo;
  public name = 'ListadoGruposComponent';
  public grupos?: IGrupo[];
  public luminarias: ILuminaria;
  public totalCount = 0;
  public columnas?: IColumnas<IGrupo>[];
  //Subs
  public grupos$?: Subscription;
  public luminarias$?: Subscription;
  //

  // Tipos de luminarias por grupo
  private groupTipos = new Map<string, Set<string>>();
  // Conteo de luminarias por grupo y tipo (para diálogo grupal de perfil)
  private groupTiposCount = new Map<string, Map<string, number>>();
  // grupoId → tipoDispositivo → [luminariaId] para luminarias con idPerfilConfig individual
  private groupLumConPerfilPorTipo: Map<string, Map<string, string[]>> =
    new Map();
  // grupoId → luminarias ACTIS del grupo (full doc con perfilConfig poblado)
  private groupLuminariasActis: Map<string, ILuminaria[]> = new Map();
  private readonly TIPO_GPE = 'Luminaria GPE';
  private readonly TIPO_ACTIS = 'Luminaria ACTIS FING';
  private readonly TIPO_WELLNESS = 'Luminaria Wellness';

  public tieneGPE(idGrupo: string): boolean {
    return this.groupTipos.get(idGrupo)?.has(this.TIPO_GPE) ?? false;
  }

  public tieneActis(idGrupo: string): boolean {
    return this.groupTipos.get(idGrupo)?.has(this.TIPO_ACTIS) ?? false;
  }

  public tieneWellness(idGrupo: string): boolean {
    return this.groupTipos.get(idGrupo)?.has(this.TIPO_WELLNESS) ?? false;
  }

  //Permisos
  private puedeEditar: AccionesRol;
  private puedeCrear: AccionesRol;
  private puedeEliminar: AccionesRol;

  public botonCrear: ICrearBoton;
  public search: IRegExpSearch = {
    fields: ['nombre'],
  };
  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  /// Trae los grupos de todos los clientes que cuelgan del elegido
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  /**
   * Integración Soflex de la flota (solo categoría Flota). Se filtra por
   * `fleetId` porque los 3 campos se cargan juntos: alcanza con ese para saber
   * si la flota está integrada. "Sin configurar" usa $in con null para que
   * entren también las flotas que nunca tuvieron el campo.
   */
  private soflex: IFiltroTabla = {
    elementos: [
      { label: 'Configurada', value: { $nin: [null, ''] } },
      { label: 'Sin configurar', value: { $in: [null, ''] } },
    ],
    filter: {
      field: 'fleetId',
    },
    label: 'Soflex',
    tipo: 'ngselect',
    selectLabel: 'label',
    selectValue: 'value',
    compararPorJson: true,
  };
  public filtros: IFiltroTabla[] = [];

  //Query
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'perfilConfigs',
      select: 'nombre valores tipoConfig',
    },
  ];
  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  // Listar
  public async listar(): Promise<void> {
    const filter: IFilter<IGrupo> = this.query.filter
      ? JSON.parse(this.query.filter)
      : {};
    filter.categoria = this.categoria;
    this.query.filter = JSON.stringify(filter);

    this.grupos$?.unsubscribe();
    this.grupos$ = this.lista2
      .grupos(this.query, 30)
      .subscribe(async (data) => {
        this.totalCount = data.totalCount;
        this.grupos = data.datos;

        // Cargar tipos de luminarias para todos los grupos
        await this.cargarTiposLuminariasParaTodosGrupos();

        // Actualizar columnas después de cargar los tipos
        this.setColumnas();
      });
  }

  private async cargarTiposLuminariasParaTodosGrupos(): Promise<void> {
    if (!this.grupos || this.grupos.length === 0) return;

    const idsGrupos = this.grupos.map((g) => g._id);

    const populate: IPopulate[] = [
      { path: 'dispositivo', select: 'tipo deveui' },
      { path: 'perfilConfig', select: 'nombre valores tipoConfig' },
    ];

    this.groupTipos.clear();
    this.groupTiposCount.clear();
    this.groupLumConPerfilPorTipo.clear();
    this.groupLuminariasActis.clear();

    try {
      if (this.categoria === 'Puesta') {
        // Agrupaciones de puesta. Cada luminaria se mapea a los grupos vía su puesta (puesta.idsGrupos).
        const puestasListado = await this.puestasService.getFiltered({
          filter: JSON.stringify({ idsGrupos: { $in: idsGrupos } }),
          select: '_id idsGrupos',
          includeChildren: true,
        });
        const puestaToGrupos = new Map<string, string[]>();
        const idsPuestas: string[] = [];
        for (const p of puestasListado.datos || []) {
          if (!p._id) continue;
          puestaToGrupos.set(p._id, p.idsGrupos || []);
          idsPuestas.push(p._id);
        }
        if (!idsPuestas.length) return;

        const data = await firstValueFrom(
          this.lista2.luminarias(
            {
              filter: JSON.stringify({ idPuesta: { $in: idsPuestas } }),
              populate: JSON.stringify(populate),
              select:
                'deveui identificacion idPuesta dispositivo idPerfilConfig perfilConfig',
              includeChildren: true,
            },
            0,
          ),
        );
        for (const luminaria of data.datos || []) {
          const tipo = luminaria?.dispositivo?.tipo;
          if (!tipo) continue;
          const grupos = puestaToGrupos.get(luminaria.idPuesta as string) || [];
          grupos.forEach((idGrupo) =>
            this.acumularTipoLuminaria(idGrupo, tipo, luminaria),
          );
        }
        return;
      }

      // Grupos de luminarias: membresía directa (luminaria.idsGrupos).
      const data = await firstValueFrom(
        this.lista2.luminarias(
          {
            filter: JSON.stringify({
              idsGrupos: { $in: idsGrupos },
            } as IFilter<ILuminaria>),
            populate: JSON.stringify(populate),
            select:
              'deveui identificacion idsGrupos dispositivo idPerfilConfig perfilConfig',
            includeChildren: true,
          },
          0,
        ),
      );
      if (data.datos) {
        data.datos.forEach((luminaria: ILuminaria) => {
          const tipo = luminaria?.dispositivo?.tipo;
          const gruposLuminaria = luminaria?.idsGrupos || [];
          if (tipo) {
            gruposLuminaria.forEach((idGrupo: string) =>
              this.acumularTipoLuminaria(idGrupo, tipo, luminaria),
            );
          }
        });
      }
    } catch (error) {
      console.error('Error cargando tipos de luminarias:', error);
    }
  }

  // Acumula el tipo de una luminaria bajo un grupo (tipos, conteos, luminarias
  // con perfil propio y lista ACTIS). Compartido por grupos de luminarias y
  // puntos de alimentación.
  private acumularTipoLuminaria(
    idGrupo: string,
    tipo: string,
    luminaria: ILuminaria,
  ): void {
    if (!this.groupTipos.has(idGrupo)) {
      this.groupTipos.set(idGrupo, new Set());
    }
    this.groupTipos.get(idGrupo)!.add(tipo);

    if (!this.groupTiposCount.has(idGrupo)) {
      this.groupTiposCount.set(idGrupo, new Map());
    }
    const counts = this.groupTiposCount.get(idGrupo)!;
    counts.set(tipo, (counts.get(tipo) || 0) + 1);

    if (luminaria.idPerfilConfig && luminaria._id) {
      if (!this.groupLumConPerfilPorTipo.has(idGrupo)) {
        this.groupLumConPerfilPorTipo.set(idGrupo, new Map());
      }
      const porTipo = this.groupLumConPerfilPorTipo.get(idGrupo)!;
      if (!porTipo.has(tipo)) {
        porTipo.set(tipo, []);
      }
      porTipo.get(tipo)!.push(luminaria._id);
    }

    if (tipo === this.TIPO_ACTIS) {
      if (!this.groupLuminariasActis.has(idGrupo)) {
        this.groupLuminariasActis.set(idGrupo, []);
      }
      this.groupLuminariasActis.get(idGrupo)!.push(luminaria);
    }
  }

  // ── Objetivo + contexto para el servicio de comandos compartido ──────────
  // El nivel se deriva de la categoría: grupo de PUESTAS (categoría 'Puesta')
  // = punto de alimentación; en otro caso, grupo de luminarias.
  private objetivo(grupo: IGrupo): Objetivo {
    return {
      id: grupo._id!,
      nivel: this.categoria === 'Puesta' ? 'grupoPuesta' : 'grupo',
      nombre: grupo.nombre,
    };
  }
  // ¿El grupo tiene un perfil del tipo dado? Si lo tiene, sus luminarias de ese
  // tipo quedan gobernadas por el perfil y NO se permiten comandos SET de ese
  // tipo desde el grupo (se ocultan).
  private grupoTienePerfilTipo(grupo: IGrupo, tipo: string): boolean {
    const tipoConfig =
      tipo === this.TIPO_ACTIS ? 'Luminaria ACTIS FING General' : tipo;
    return (grupo.perfilConfigs || []).some(
      (p) => p?.tipoConfig === tipoConfig,
    );
  }

  // Render de los perfiles asignados directamente (propios) a un grupo/puesta:
  // el ícono de perfil y, al lado, el tipo de configuración.
  public htmlPerfilPropio(perfiles?: IConfigPerfil[] | null): string {
    if (!perfiles?.length) return '';
    let html = `<div class="tabla-celda-col">`;
    for (const p of perfiles) {
      const tipo = p?.tipoConfig || '';
      html += `<div class="tabla-linea" title="${escaparHtml(tipo)}">`;
      html += `<span class="material-symbols-outlined">tune</span>`;
      html += p?.nombre
        ? `<span>${escaparHtml(p.nombre)}</span>`
        : `<span class="no-info">Sin nombre</span>`;
      if (tipo) {
        html += `<span class="tabla-secundario">${escaparHtml(tipo)}</span>`;
      }
      html += `</div>`;
    }
    html += `</div>`;
    return html;
  }

  /// Datos de la integración Soflex de una flota: una fila por campo. Los 3 van
  /// juntos, si falta alguno el vehículo no se sincroniza ni reenvía posiciones.
  public htmlSoflex(grupo: IGrupo): string {
    const campos: [string, string | undefined][] = [
      ['Fleet ID', grupo.fleetId],
      ['Parent Fleet ID', grupo.parentFleetId],
      ['Fleet Name', grupo.fleetName],
    ];

    if (campos.every(([, valor]) => !valor)) return '';

    let html = `<div class="tabla-celda-col">`;
    for (const [label, valor] of campos) {
      const contenido = valor
        ? `<span>${escaparHtml(valor)}</span>`
        : `<span class="no-info">Sin dato</span>`;
      html += `<div class="tabla-celda-fila"><span class="tabla-secundario">${label}:</span>${contenido}</div>`;
    }
    html += `</div>`;
    return html;
  }

  public crear() {
    const res = this.formularios.abrir(CrearEditarAgrupacionesComponent, {
      tamano: 'mediano',
      data: {
        categoria: this.categoria,
      },
    });
    if (res) {
      res.afterClosed().subscribe((r) => {
        if (r) {
          this.listar();
        }
      });
    }
  }

  public async editar(grupo: IGrupo) {
    const res = this.formularios.abrir(CrearEditarAgrupacionesComponent, {
      tamano: 'mediano',
      data: {
        edit: grupo,
        categoria: this.categoria,
      },
    });
    if (res) {
      res.afterClosed().subscribe((r) => {
        if (r) {
          this.listar();
        }
      });
    }
  }

  // Abre el asignador de entidades de este grupo (ruta grupos/:categoria/asignar/:id).
  public asignarEntidades(grupo: IGrupo) {
    this.navigator.navigate(['asignar', grupo._id], { relativeTo: this.route });
  }

  // Dashboard del grupo (página con gráficos no técnicos + consumo). Para grupos
  // de luminarias (categoria 'Luminaria') y puntos de alimentación ('Puesta').
  public verDetalle(grupo: IGrupo): void {
    const nivel =
      this.categoria === 'Puesta' ? 'grupoPuesta' : 'grupoLuminaria';
    this.navigator.navigate(
      ['main/luminarias/detalle-entidad', nivel, grupo._id],
      { queryParams: { nombre: grupo.nombre } },
    );
  }

  // Exporta a Excel las luminarias del grupo (de luminarias o de puestas).
  public async exportar(grupo: IGrupo): Promise<void> {
    const nivel = this.categoria === 'Puesta' ? 'grupoPuesta' : 'grupo';
    const config = await firstValueFrom(
      this.formularios
        .abrir(ExportarLuminariasDialogComponent, {
          tamano: 'chico',
          data: { nivel },
        })
        .afterClosed(),
    );
    if (!config) return;
    const fecha = new Date().toISOString().slice(0, 10);
    const prefijo =
      nivel === 'grupoPuesta' ? 'grupoPuestas' : 'grupoLuminarias';
    // Job asíncrono: un grupo grande trae el mes completo de eventos y
    // comandos, que no entra en una request. El panel de Descargas pollea.
    const nombre = `${prefijo}_${grupo.nombre ?? grupo._id}_${fecha}`;
    this.descargas.agregarDescargaJob(nombre, {
      crearJob: () =>
        this.luminariasHttp.crearExportJob(
          { nivel, id: grupo._id! },
          config,
          `${nombre}.xlsx`,
        ),
      consultarEstado: (jobId) => this.luminariasHttp.getExportJob(jobId),
      descargarArchivo: (jobId) =>
        this.luminariasHttp.descargarExportJob(jobId),
    });
    this.helper.notifSuccess('Exportación iniciada — ver panel de Descargas');
  }

  public async eliminar(agrupacion: IGrupo) {
    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Querés eliminar el grupo ${agrupacion.nombre}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(agrupacion._id!);
      this.helper.notifSuccess('Eliminado correctamente');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  /**
   * Vuelve el flag de Soflex a false en todos los vehículos de la flota: la
   * próxima sincronización los va a reenviar (sólo manda los pendientes).
   */
  public async desmarcarSoflexFlota(grupo: IGrupo): Promise<void> {
    const res = await this.dialogService.confirm(
      'Marcar como no sincronizados',
      `¿Querés marcar todos los vehículos de la flota ${grupo.nombre} como no sincronizados con Soflex? Se volverán a enviar en la próxima sincronización.`,
    );
    if (!res) return;
    try {
      const { desmarcados } = await this.activosService.desmarcarSoflexFlota(
        grupo._id!,
      );
      this.helper.notifSuccess(
        desmarcados
          ? `${desmarcados} vehículo(s) marcados como no sincronizados`
          : 'La flota no tenía vehículos sincronizados',
      );
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public eventosPersonalizados(agrupacion: IGrupo): void {
    this.navigator.navigate(
      ['main/eventosPersonalizados', this.categoria, agrupacion._id],
      { queryParams: { nombre: agrupacion.nombre } },
    );
  }

  ////////////////////////////////////////////////////////////////////////
  // COMANDOS — delegados al servicio compartido ComandosObjetivoService.
  // El servicio resuelve diálogos, flujo de perfil y elegibilidad por
  // jerarquía. El nivel (grupo / punto de alimentación) lo da objetivo().
  ////////////////////////////////////////////////////////////////////////

  // GPE
  public async encenderGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.encenderGPE(this.objetivo(grupo));
  }
  public async apagarGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.apagarGPE(this.objetivo(grupo));
  }
  public async cambiarModoGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.cambiarModoGPE(this.objetivo(grupo));
  }
  public async consultarConfigGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.consultarConfigGPE(this.objetivo(grupo));
  }
  public async createConfigGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.createConfigGPE(this.objetivo(grupo));
  }
  public async configCalendarioGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.configCalendarioGPE(this.objetivo(grupo));
  }
  public async consultarConfigCalendarioGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.consultarConfigCalendarioGPE(this.objetivo(grupo));
  }
  public async pedirGPSGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.pedirGPSGPE(this.objetivo(grupo));
  }
  public async resetGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.resetGPE(this.objetivo(grupo));
  }
  public async resetEnergiaGrupoGPE(grupo: IGrupo): Promise<void> {
    await this.comandos.resetEnergiaGPE(this.objetivo(grupo));
  }

  // ACTIS
  public async encenderGrupoActis(grupo: IGrupo): Promise<void> {
    await this.comandos.encenderActis(this.objetivo(grupo));
  }
  public async apagarGrupoActis(grupo: IGrupo): Promise<void> {
    await this.comandos.apagarActis(this.objetivo(grupo));
  }
  public async cambiarModoGrupoActis(grupo: IGrupo): Promise<void> {
    await this.comandos.cambiarModoActis(this.objetivo(grupo));
  }
  public async consultarConfigGrupoActis(grupo: IGrupo): Promise<void> {
    await this.comandos.consultaActis(this.objetivo(grupo), 'config');
  }
  public async configActisGrupo(
    grupo: IGrupo,
    config: TipoConfigActis,
  ): Promise<void> {
    await this.comandos.configActis(this.objetivo(grupo), config);
  }
  public async consultaActisGrupo(
    grupo: IGrupo,
    config: TipoConsultaActis,
  ): Promise<void> {
    await this.comandos.consultaActis(this.objetivo(grupo), config);
  }

  // PERFIL (GPE + ACTIS)
  public async reaplicarPerfilGrupo(grupo: IGrupo): Promise<void> {
    await this.comandos.reaplicarPerfil(this.objetivo(grupo));
  }

  // WELLNESS
  public async encenderGrupoWellness(grupo: IGrupo): Promise<void> {
    await this.comandos.encenderWellness(this.objetivo(grupo));
  }
  public async apagarGrupoWellness(grupo: IGrupo): Promise<void> {
    await this.comandos.apagarWellness(this.objetivo(grupo));
  }

  // Visualizador de jerarquía de perfiles del objetivo (grupo / punto alim.).
  public verJerarquia(grupo: IGrupo): void {
    this.dialogService.jerarquiaPerfiles({
      nivel: this.categoria === 'Puesta' ? 'grupoPuesta' : 'grupo',
      id: grupo._id!,
      nombre: grupo.nombre,
    });
  }

  ////////////////////////////////////////////////////////////////////////

  private setColumnas() {
    const columnas: IColumnas<IGrupo>[] = [
      // Nombre: badge del color del grupo con el nombre adentro
      {
        header: {
          label: 'Nombre',
          sortable: true,
          sort: 'nombre',
        },
        row: {
          html(dato) {
            if (!dato.nombre) return '';
            return estadoHtml({
              texto: dato.nombre,
              tono: 'neutro',
              color: dato.color,
            });
          },
          noData: 'Sin nombre',
        },
      },
      // Color: código del color (el color se ve en el badge del nombre)
      {
        header: {
          label: 'Color',
        },
        row: {
          html(dato) {
            if (!dato.color) return '';
            return colorMuestraHtml(dato.color);
          },
          noData: 'Sin color',
        },
      },
    ];

    // Prioridad (solo categorías con perfiles: define qué grupo gana al
    // heredar perfil cuando una luminaria/puesta pertenece a varios grupos)
    if (this.categoria === 'Luminaria' || this.categoria === 'Puesta') {
      columnas.push({
        header: { label: 'Prioridad', sortable: true, sort: 'prioridad' },
        row: {
          parse: (dato) =>
            dato.prioridad != null ? `${dato.prioridad}` : undefined,
          noData: 'Sin prioridad',
        },
      });
    }

    // Cliente. En flotas se muestra además la jerarquía de clientes en un
    // tooltip: con varios clientes de nombre parecido el nombre solo no alcanza
    // para saber de quién cuelga la flota.
    if (HelperService.getTipoCliente() !== 'Final') {
      columnas.push({
        header: {
          label: 'Cliente',
        },
        row: {
          html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
          tooltip: (dato) =>
            this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          noData: 'Sin cliente',
        },
      });
    }

    // Perfil propio (perfiles asignados directamente a este grupo): sólo las
    // categorías que tienen perfiles, o sea las de luminarias.
    if (this.categoria === 'Luminaria' || this.categoria === 'Puesta') {
      columnas.push({
        header: { label: 'Perfil propio' },
        row: {
          html: (dato) => this.htmlPerfilPropio(dato.perfilConfigs),
          noData: 'Sin perfil',
        },
      });
    }

    // Integración Soflex (sólo flotas): los 3 campos que se cargan juntos
    if (this.categoria === 'Flota') {
      columnas.push({
        header: { label: 'Integración Soflex' },
        row: {
          html: (dato) => this.htmlSoflex(dato),
          noData: 'Sin integración',
        },
      });
    }

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        accionesGrouped: [
          // Detalle (dashboard) — solo grupos de luminarias / puntos de alimentación
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            oculta: () =>
              this.categoria !== 'Luminaria' && this.categoria !== 'Puesta',
            click: (dato) => this.verDetalle(dato),
          },
          // Editar
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () => !this.helper.tienePermiso(this.puedeEditar),
          },
          // Asignar entidades al grupo (solo categorías soportadas)
          {
            tipo: 'material',
            color: 'primary',
            icon: 'group_add',
            tooltip: 'Asignar entidades',
            click: (dato) => this.asignarEntidades(dato),
            oculta: () => !this.registryEntidades.soportada(this.categoria),
            disabled: () => !this.helper.tienePermiso(this.puedeEditar),
          },
          // Eliminar
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso(this.puedeEliminar),
          },

          // Eventos personalizados — ocultos para agrupaciones de luminarias
          // (grupos de luminarias y puntos de alimentación / puestas).
          {
            tipo: 'material',
            color: 'primary',
            icon: 'rule',
            tooltip: 'Eventos personalizados',
            oculta: () =>
              this.categoria === 'Luminaria' || this.categoria === 'Puesta',
            click: (dato) => this.eventosPersonalizados(dato),
          },

          // Marcar la flota entera como pendiente de Soflex: la sincronización
          // sólo envía los vehículos sin el flag, así que esta es la forma de
          // forzar el reenvío de todos los de una flota de una sola vez.
          {
            tipo: 'material',
            color: 'primary',
            icon: 'sync_problem',
            tooltip: 'Marcar vehículos como no sincronizados con Soflex',
            oculta: () => this.categoria !== 'Flota',
            click: (dato) => this.desmarcarSoflexFlota(dato),
            disabled: () => !this.helper.tienePermiso('Vehículos - Editar'),
          },

          // Ver jerarquía de perfiles (solo grupos de luminarias / puntos alim.)
          {
            tipo: 'material',
            color: 'primary',
            icon: 'account_tree',
            tooltip: 'Ver jerarquía de perfiles',
            oculta: () =>
              this.categoria !== 'Luminaria' && this.categoria !== 'Puesta',
            click: (dato) => this.verJerarquia(dato),
          },
          // Exportar a planilla las luminarias del grupo
          {
            tipo: 'material',
            color: 'primary',
            icon: 'table_view',
            tooltip: 'Exportar a planilla',
            oculta: () =>
              this.categoria !== 'Luminaria' && this.categoria !== 'Puesta',
            click: (dato) => this.exportar(dato),
          },
          // Reaplicar perfil a todas las luminarias del objetivo (GPE + ACTIS).
          // Sirve para recuperar la config tras un cambio de firmware masivo:
          // el nodo la perdió pero el sistema la sigue creyendo aplicada.
          {
            tipo: 'material',
            color: 'primary',
            icon: 'published_with_changes',
            tooltip: 'Reaplicar perfil',
            oculta: () =>
              this.categoria !== 'Luminaria' && this.categoria !== 'Puesta',
            disabled: () =>
              !this.helper.tienePermiso('Luminarias - Enviar comandos'),
            click: (dato) => this.reaplicarPerfilGrupo(dato),
          },

          // ── MENÚ COMANDOS GPE ──────────────────────────────────────
          {
            tipo: 'material',
            icon: 'settings_remote',
            tooltip: 'Comandos GPE',
            oculta: (dato) =>
              (this.categoria !== 'Luminaria' && this.categoria !== 'Puesta') ||
              !this.tieneGPE(dato._id),
            disabled: () =>
              !this.helper.tienePermiso('Luminarias - Enviar comandos'),
            children: filtrarComandosManuales([
              {
                tipo: 'material',
                color: 'primary',
                icon: 'lightbulb',
                tooltip: 'Encender',
                click: (dato) => this.encenderGrupoGPE(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'light_off',
                tooltip: 'Apagar',
                click: (dato) => this.apagarGrupoGPE(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'settings_suggest',
                tooltip: 'Cambiar modo',
                click: (dato) => this.cambiarModoGrupoGPE(dato),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_GPE),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar configuración',
                click: (dato) => this.consultarConfigGrupoGPE(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'tune',
                tooltip: 'Cambiar configuración',
                click: (dato) => this.createConfigGrupoGPE(dato),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_GPE),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'calendar_view_month',
                tooltip: 'Configuración del calendario',
                click: (dato) => this.configCalendarioGrupoGPE(dato),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_GPE),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar calendario',
                click: (dato) => this.consultarConfigCalendarioGrupoGPE(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'my_location',
                tooltip: 'Pedir GPS',
                click: (dato) => this.pedirGPSGrupoGPE(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'power_settings_new',
                tooltip: 'Resetear',
                click: (dato) => this.resetGrupoGPE(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'power_settings_new',
                tooltip: 'Resetear energía',
                click: (dato) => this.resetEnergiaGrupoGPE(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
            ]),
          },

          // ── MENÚ COMANDOS ACTIS ─────────────────────────────────────
          {
            tipo: 'material',
            icon: 'settings_remote',
            tooltip: 'Comandos ACTIS',
            oculta: (dato) =>
              (this.categoria !== 'Luminaria' && this.categoria !== 'Puesta') ||
              !this.tieneActis(dato._id),
            disabled: () =>
              !this.helper.tienePermiso('Luminarias - Enviar comandos'),
            children: filtrarComandosManuales([
              {
                tipo: 'material',
                color: 'primary',
                icon: 'lightbulb',
                tooltip: 'Encender',
                click: (dato) => this.encenderGrupoActis(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'light_off',
                tooltip: 'Apagar',
                click: (dato) => this.apagarGrupoActis(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'settings_suggest',
                tooltip: 'Cambiar modo',
                click: (dato) => this.cambiarModoGrupoActis(dato),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_ACTIS),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar configuración',
                click: (dato) => this.consultarConfigGrupoActis(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'wb_twilight',
                tooltip: 'Configuración astronómica',
                click: (dato) => this.configActisGrupo(dato, 'Offset'),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_ACTIS),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'wb_sunny',
                tooltip: 'Configuración de fotocélula',
                click: (dato) => this.configActisGrupo(dato, 'Treshold'),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_ACTIS),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'my_location',
                tooltip: 'Configuración de coordenadas',
                click: (dato) => this.configActisGrupo(dato, 'Coordinates'),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_ACTIS),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar estado',
                click: (dato) => this.consultaActisGrupo(dato, 'estado'),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar configuración general',
                click: (dato) => this.consultaActisGrupo(dato, 'configGeneral'),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'schedule_send',
                tooltip: 'Configurar reportes',
                click: (dato) => this.configActisGrupo(dato, 'Reporte'),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_ACTIS),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'verified',
                tooltip: 'Configurar ACK',
                click: (dato) => this.configActisGrupo(dato, 'ACK'),
                oculta: (dato) =>
                  this.grupoTienePerfilTipo(dato, this.TIPO_ACTIS),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
            ]),
          },

          // ── MENÚ COMANDOS WELLNESS ──────────────────────────────────
          {
            tipo: 'material',
            icon: 'settings_remote',
            tooltip: 'Comandos Wellness',
            oculta: (dato) =>
              (this.categoria !== 'Luminaria' && this.categoria !== 'Puesta') ||
              !this.tieneWellness(dato._id),
            disabled: () =>
              !this.helper.tienePermiso('Luminarias - Enviar comandos'),
            children: [
              {
                tipo: 'material',
                color: 'primary',
                icon: 'lightbulb',
                tooltip: 'Encender',
                click: (dato) => this.encenderGrupoWellness(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'light_off',
                tooltip: 'Apagar',
                click: (dato) => this.apagarGrupoWellness(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
            ],
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  /// HOOKS

  public async ngOnInit(): Promise<void> {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }

    this.route.params.subscribe(async (params) => {
      this.categoria = params['categoria'] as CategoriaGrupo;

      // El filtro de Soflex sólo aplica a flotas: se saca y se vuelve a poner
      // según la categoría de la ruta (el subscribe corre de nuevo al navegar).
      const indiceSoflex = this.filtros.indexOf(this.soflex);
      if (indiceSoflex >= 0) this.filtros.splice(indiceSoflex, 1);

      switch (this.categoria) {
        case 'Línea de colectivo':
          this.puedeCrear = 'Colectivos - Crear líneas';
          this.puedeEditar = 'Colectivos - Editar líneas';
          this.puedeEliminar = 'Colectivos - Eliminar líneas';
          break;

        case 'Flota':
          this.puedeCrear = 'Vehículos - Crear flotas';
          this.puedeEditar = 'Vehículos - Editar flotas';
          this.puedeEliminar = 'Vehículos - Eliminar flotas';
          this.filtros.push(this.soflex);
          break;

        case 'Activo':
        case 'Normal': //No sé exactamente que es la categoría normal y no tengo ni idea si se usa, pero considero que es activo
          this.puedeCrear = 'Activos - Crear agrupaciones';
          this.puedeEditar = 'Activos - Editar agrupaciones';
          this.puedeEliminar = 'Activos - Eliminar agrupaciones';
          break;

        case 'Luminaria':
        case 'Puesta':
          this.puedeCrear = 'Luminarias - Crear agrupaciones';
          this.puedeEditar = 'Luminarias - Editar agrupaciones';
          this.puedeEliminar = 'Luminarias - Eliminar agrupaciones';
          break;
      }

      this.botonCrear = {
        mostrar: this.helper.tienePermiso(this.puedeCrear),
        tooltip: 'Crear',
        color: 'primary',
        tipo: 'material',
        icon: 'add',
        accion: () => this.crear(),
      };
      // Dentro del subscribe: las columnas dependen de la categoría de la ruta
      this.setColumnas();
      await this.listar();
    });
  }

  public async ngOnDestroy(): Promise<void> {
    this.grupos$?.unsubscribe();
  }
}
